module.exports = __webpack_public_path__ + "static/WorqFlexi-4c19e780ab57dce99ac0579eeb7dcc8b.png";